import { DataLinkBuiltInVars } from '@grafana/data';
import { UrlTimeRangeMacro } from './UrlTimeRangeMacro.js';
import { AllVariablesMacro } from './AllVariablesMacro.js';
import { ValueMacro, DataMacro, SeriesMacro, FieldMacro } from './dataMacros.js';

const macrosIndex = {
  [DataLinkBuiltInVars.includeVars]: AllVariablesMacro,
  [DataLinkBuiltInVars.keepTime]: UrlTimeRangeMacro,
  ["__value"]: ValueMacro,
  ["__data"]: DataMacro,
  ["__series"]: SeriesMacro,
  ["__field"]: FieldMacro
};

export { macrosIndex };
//# sourceMappingURL=index.js.map
